if (!customElements.get('popular-brands-carousel')) {
  customElements.define(
    'popular-brands-carousel',
    class PopularBrandsCarousel extends HTMLElement {
      connectedCallback() {
        // Only run the desktop slider when there are enough brands to scroll (>6).
        // With 6 or fewer, CSS distributes them evenly and no slider is needed.
        this.enableCarousel = this.dataset.enableCarousel === 'true';
        this.mediaQuery = window.matchMedia(FoxTheme.config.mediaQueryMobile);

        if (!this.enableCarousel) return;

        if (!this.mediaQuery.matches) {
          this.initSlider();
        }

        this.mediaQuery.addEventListener('change', (e) => {
          if (!e.matches) {
            this.initSlider();
          } else if (this.sliderInstance) {
            this.sliderInstance.destroy();
            this.sliderInstance = null;
          }
        });
      }

      // Controls live outside the swiper element (sibling), so query them from the section content.
      get controlsScope() {
        return this.closest('.section__content') || this.parentElement || document;
      }

      initSlider() {
        const scope = this.controlsScope;
        this.sliderInstance = new window.FoxTheme.Carousel(this, {
          modules: [FoxTheme.Swiper.Pagination, FoxTheme.Swiper.Mousewheel, FoxTheme.Swiper.Navigation],
          slidesPerView: 'auto',
          spaceBetween: 12,
          grabCursor: true,
          simulateTouch: true,
          watchOverflow: true,
          pagination: {
            el: scope.querySelector('.swiper-pagination'),
            type: 'progressbar',
          },
          navigation: {
            prevEl: scope.querySelector('.swiper-button-prev'),
            nextEl: scope.querySelector('.swiper-button-next'),
          },
          breakpoints: {
            768: { spaceBetween: 16 },
          },
          threshold: 2,
          mousewheel: {
            enabled: true,
            // Only respond to horizontal wheel/trackpad input so vertical page
            // scrolling is never hijacked.
            forceToAxis: true,
            sensitivity: 0.3,
          },
        });
        this.sliderInstance.init();
        this.initScrollbarDrag();
      }

      // Let the progressbar be grabbed/dragged to scrub the carousel.
      initScrollbarDrag() {
        if (this._barDragInit) return;
        const bar = this.controlsScope.querySelector('.swiper-pagination');
        if (!bar) return;
        this._barDragInit = true;
        bar.style.pointerEvents = 'auto';
        bar.style.cursor = 'pointer';

        let down = false;
        const scrub = (clientX) => {
          const swiper = this.sliderInstance && this.sliderInstance.slider;
          if (!swiper) return;
          const rect = bar.getBoundingClientRect();
          if (rect.width <= 0) return;
          let ratio = (clientX - rect.left) / rect.width;
          ratio = Math.min(1, Math.max(0, ratio));
          swiper.setProgress(ratio);
        };

        bar.addEventListener('pointerdown', (e) => {
          if (e.button !== 0) return;
          down = true;
          try { bar.setPointerCapture(e.pointerId); } catch (err) {}
          scrub(e.clientX);
        });
        bar.addEventListener('pointermove', (e) => {
          if (down) scrub(e.clientX);
        });
        const end = (e) => {
          if (!down) return;
          down = false;
          try { bar.releasePointerCapture(e.pointerId); } catch (err) {}
        };
        bar.addEventListener('pointerup', end);
        bar.addEventListener('pointercancel', end);
      }
    }
  );
}
